import service from "@/api/service";
import { GetResponse } from "@/api/shop-coupon/response";
import { SearchRequest } from "@/api/shop-coupon/request";
import { SearchResponse } from "@/api/shop-coupon/response";

/**
 * クーポン店舗一覧・検索APIをコールします。
 *
 * @param searchRequest 検索のリクエストボディ
 * @return SearchResponse
 */
export async function search(searchRequest: SearchRequest) {
  const response = await service.post("/search-coupon-shop", searchRequest);
  return response.data as SearchResponse;
}

/**
 * クーポン店舗情報取得APIをコールします。
 *
 * @return GetResponse
 */
export async function get() {
  const response = await service.post("/get-coupon-shop");
  return response.data as GetResponse;
}
